// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uN4_","textarea":"styles_textarea__34VJb"};